var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEVELOPMENT_PATTERN = void 0;
const isDevServer_1 = __importDefault(require("./isDevServer"));
exports.DEVELOPMENT_PATTERN = /dev\.hendersonengineers\.com/i;
function isDevelopment(url) {
    const urlToTest = url || window.location.host;
    return (0, isDevServer_1.default)(urlToTest) || exports.DEVELOPMENT_PATTERN.test(urlToTest);
}
exports.default = isDevelopment;
//# sourceMappingURL=isDevelopment.js.map